import useAxios from "axios-hooks";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Error from "../Error";
import FormWrapper from "../styles/FormWrapper";
import InputFormContainer from "../styles/InputFormContainer";
import QueryLoading from "../animations/QueryLoading";
import { API_URL } from "../../config";
import { useSpring, animated } from "react-spring";

const Login = ({ refetchUser, location }) => {
  const [{ loading, error }, signin] = useAxios(
    {
      url: `${API_URL}/signin`,
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const [touched, settouched] = useState(false);

  const props = useSpring({
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  });

  if (error) {
    console.log(error);
  }
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const handleSubmit = (event) => {
    event.preventDefault();

    signin({
      data: {
        email,
        password,
      },
    })
      .then(() => {
        refetchUser();
      })
      .catch((error) => {
        console.log(error.response.data);
        settouched(false);
      });
  };
  return (
    <>
      {loading ? (
        <QueryLoading />
      ) : (
        <InputFormContainer>
          <animated.div style={props}>
            <h2>Sign in</h2>

            <FormWrapper onSubmit={handleSubmit}>
              <p>
                <label htmlFor="email">Email address</label>

                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={(event) => {
                    setemail(event.target.value);
                    settouched(true);
                  }}
                />
              </p>

              <p>
                <label htmlFor="password">Password</label>

                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={(event) => {
                    setpassword(event.target.value);
                    settouched(true);
                  }}
                />
              </p>
              <p>
                <Link to="/forgot">Forgot your password?</Link>
              </p>
              {error && !touched ? (
                <Error message={error.response.data.message} />
              ) : null}

              <button type="submit">Sign in</button>
            </FormWrapper>
          </animated.div>
        </InputFormContainer>
      )}
    </>
  );
};

export default Login;
